/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

import './bootstrap'

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import './wijmoLicense.js'

import './components/jsx/input/Period.jsx'
import './components/jsx/input/MyReactInput.jsx'
import './components/jsx/input/MyReactSelect.jsx'
import './components/jsx/input/MyReactMultiSelect.jsx'
import './components/jsx/input/MyDatePicker.jsx'
import './components/jsx/input/InteractiveDialogInput.jsx'
import './components/jsx/input/SuggestingSelector.jsx'
import './components/jsx/input/PostalCodeInput.jsx'
import './components/jsx/input/PhoneNumberInput.jsx'

import './components/jsx/element/CollapseButton.jsx'

import './components/jsx/licensee/NewContractItemGrid.jsx'
import './components/jsx/licensee/AddressSetter.jsx'
import './components/jsx/licensee/ApplicationListContract.jsx'
import './components/jsx/licensee/ApplicationListTrade.jsx'
import './components/jsx/licensee/ShareGroupDialog.jsx'
import './components/jsx/licensee/ItemsGrid.jsx'
import './components/jsx/licensee/ItemsRegisterGrid.jsx'
import './components/jsx/licensee/ItemsStampDataGrid.jsx'
import './components/jsx/licensee/ItemsCategoryGrid.jsx'
import './components/jsx/licensee/XrContractsGrid.jsx'
import './components/jsx/licensee/XrContractsRegisterGrid.jsx'
import './components/jsx/licensee/XrRightsGrid.jsx'
import './components/jsx/licensee/CharacterSelect.jsx'
import './components/jsx/licensee/ItemsFilterInputs.jsx'
import './components/jsx/licensee/TradeDraftModal.jsx'
import './components/jsx/licensee/DraftDeleteModal.jsx'
import './components/jsx/licensee/TradeClearModal.jsx'

import './components/jsx/shopro/ApplicationListAccount.jsx'
import './components/jsx/shopro/ApplicationListStampData.jsx'
import './components/jsx/shopro/WorkflowTemplateEditor.jsx'
import './components/jsx/shopro/WorkflowList.jsx'
import './components/jsx/shopro/WorkflowSetter.jsx'
import './components/jsx/shopro/WorkflowEditor.jsx'
import './components/jsx/shopro/WorkflowProgress.jsx'
import './components/jsx/shopro/WfComment.jsx'
import './components/jsx/shopro/WfModalApprove.jsx'
import './components/jsx/shopro/WfModalDecline.jsx'
import './components/jsx/shopro/WfModalCancel.jsx'
import './components/jsx/shopro/WfModalReject.jsx'
import './components/jsx/shopro/CoopProductClassSelector.jsx'
import './components/jsx/shopro/CoopTrdDtPicker.jsx'
import './components/jsx/shopro/ModalApplicationDeadline.jsx'
import './components/jsx/shopro/ContractDraftModal.jsx'

import './components/jsx/share_group/ShareGroupList.jsx'
import './components/jsx/share_group/ShareGroupEdit.jsx'

import './components/jsx/Icons.jsx'
import './components/jsx/ConfirmModal.jsx'

import './fuoc.js'
import './termWindow.js'
import './confirmModalForItemsRegister.js'
import './royalityWithTax.js'
import './exportItemsTable.js'
import './switchHiddenByRadio.js'

$(function () {
  $('.help-popover').popover({
    trigger: 'hover',
    html: true
  })

  // ボタンを連続でクリックできないようにする処理
  /*
  $('button.accept-once').on('click', (e) => {
    e.preventDefault()
    const button = e.currentTarget
    button.form?.requestSubmit(button)
    button.disabled = true
  })
  */

  // form内でEnter押下時にsubmitしない設定
  $('form').each((i, el) => {
    // data-disable-submit=trueを指定したformに適用
    if ($(el).data().disableSubmit) {
      $(el).on('keydown', (e) => {
        if (e.key === 'Enter') {
          if (e.target.tagName !== 'TEXTAREA') {
            e.preventDefault()
          }
        }
      })
    }
  })

  // 全体切り替えcheckboxの処理
  $('.check-all').on('change', (e) => {
    const targets = $('input.' + $(e.target).data().allFor)
    targets.each((i, el) => {
      el.checked = e.target.checked
      $(el).trigger('change')
    })
  })
  $('.check-all').each((i, el) => {
    const targets = $('input.' + $(el).data().allFor)
    el.checked = targets.toArray().every((target) => target.checked)
  })
  // checkedなcheckboxの個数を表示する処理
  $('.check-count').each((i, el) => {
    const targets = $('input.' + $(el).data().target)
    targets.on('change', (e) => {
      el.innerText = targets.filter((i) => targets[i].checked).length
    })
    targets.trigger('change')
  })

  // 変更すると対応するクエリパラメータを切り替えてリロードするcheckboxの処理
  $('input.check-reload').each((i, el) => {
    el.addEventListener('change', (e) => {
      const inputName = el.name
      const url = new URL(location.href)
      url.searchParams.set(inputName, el.checked ? 1 : 0)
      location.href = url.href
    })
  })

  // サイドバーの開閉処理
  const sidebar = $('.sidebar')
  const ssClose = $('.sidebar-switch-close')
  const ssOpen = $('.sidebar-switch-open')
  const storageKey = 'sidebar-close'
  ssClose.on('click', (e) => {
    sidebar.addClass('d-none')
    ssOpen.show()
    localStorage.setItem(storageKey, '1')
  })
  ssOpen.on('click', (e) => {
    sidebar.removeClass('d-none')
    ssOpen.hide()
    localStorage.setItem(storageKey, '0')
  })

  const storageClose = localStorage.getItem(storageKey)
  if (storageClose === '1') {
    ssClose.trigger('click')
  } else {
    ssOpen.trigger('click')
  }

  // ShoProアカウント編集画面で、自身のis_managerフラグを変更しようとしたときに確認ダイアログを表示する
  $('.check-is-manager').on('change', (e) => {
    if (!e.target.checked) {
      const result = window.confirm('自身の管理者設定を変更した場合、保存後は自身で元に戻すことができなくなります。変更しますか？')
      if (!result) {
        e.target.checked = true
      }
    }
  })

  $('input[name="wf_completed"]').on('change', (e) => {
    const disabled = e.currentTarget.value === '1' && e.currentTarget.checked
    $('.cb-status').each((i, el) => { el.disabled = disabled })
    $('#statusCheckboxAll').each((i, el) => { el.disabled = disabled })
  })
  $('input[name="wf_completed"]').trigger('change')

  document.querySelectorAll('input[name="show_all_status"]').forEach((el) => {
    el.addEventListener('change', (e) => {
      document.getElementById('wfStatusBlock').style.display = (e.target.checked ? 'none' : 'block')
    })
    document.getElementById('wfStatusBlock').style.display = (el.checked ? 'none' : 'block')
  })
})

// フッターのフェードイン・フェードアウト処理
function contentsOuterOnScroll (target, fadeSpeed) {
  const threshold = 3
  if ((target.scrollHeight - target.clientHeight) - target.scrollTop < threshold) {
    $('.fade-footer').fadeIn(fadeSpeed)
  } else {
    $('.fade-footer').fadeOut(fadeSpeed)
  }
}

$(window).on('load resize', () => {
  $('.contents-outer').each((i, el) => contentsOuterOnScroll(el, 0))

  // タイトルを自動変更
  const h1 = $('.contents-outer').find('h1')
  if (h1.length) {
    $('title').text(`${h1[0].innerText} - ${$('title').text()}`)
  }
})

$(window).on('load', () => {
  // 動的変更する戻るリンクの設定
  const ref = document.referrer
  // refがあり、同じホストからの遷移のときだけリンクを変更
  if (ref && ref.indexOf(location.host) > -1) {
    // refが現在地と異なる内容のときだけリンクを変更
    if (!(new URL(location.href)).searchParams.get('hb') && ref !== location.href) {
      $('a.historyback').each((i, el) => {
        const except = $(el).data('historyback-except')
        if (except && !Array.isArray(except)) {
          console.error('a.historyback要素のdata-historyback-except属性には配列を指定してください。')
        }
        const matchExcept = except ? except.some((url) => ref.indexOf(url) > -1) : false
        if (!matchExcept) {
          const url = new URL(ref)
          url.searchParams.set('hb', 1)
          $(el).attr('href', url.href)
        }
      })
    }
  }
})

$('.contents-outer').on('scroll', (e) => {
  contentsOuterOnScroll(e.target, 200)
})
